import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import { Link, useLocation } from 'react-router-dom'
import ConsentManager from "@/modules/frontend/components/ConsentManager";
import PopUp from "@/modules/frontend/components/PopUp";
import BookADemo from "@/modules/frontend/components/BookADemo";

import OutServiceDigital from "@/assets/images/webp/our-service-digital-service-img.webp";
import OutServiceCertificate from "@/assets/images/webp/our-service-certification-img.webp";
import OutServicePramotion from "@/assets/images/webp/our-service-end-to-end-img.webp";
import OutServiceDedication from "@/assets/images/webp/our-service-customer-img.webp";
import OutServiceVerification from "@/assets/images/webp/our-service-verification-img.webp";

import { motion } from "framer-motion";
import { publicRoutePaths } from "@/routes/public.routes.config";

const Index = () => {

  const location = useLocation();

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  useEffect(() => {
    // Scroll to the section indicated by the hash in the URL
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [location]);

  useEffect(() => {
    setSelectedLanguage(localStorage.getItem("web_lang"));
  }, []);

  return (
    <section className='inner-page page our-services-page services'>
      <SeoHelmet
        title={seoConfig.services.title}
        description={seoConfig.services.description}
        keywords={seoConfig.services.keywords}
        author={seoConfig.services.author}
      />

      <button
        className="btn outline small sticky-btn"
        onClick={handleQuoteClick}
        type="button"
      >
        Book A Demo
      </button>

      {/* inner banner wrape START  */}
      <div className="inner-banner">
        <div className="container">
          {
            selectedLanguage === "en" ? <div className="content-wrape desk-hide">
              <h2>
                <motion.span className="light animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                >Smarter</motion.span>
                <motion.span className="blue-text animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                > Services</motion.span>
                <motion.span className="black animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                > for Growth</motion.span>
              </h2>
              <motion.p className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                custom={0.1}
                variants={fadeUpVariant}
              >Flexible, reliable and built for success across a global business network.</motion.p>
            </div> : <div className="content-wrape desk-hide">
              <h2>
                <span className="light">Smarter</span>
                <span className="blue-text"> Services</span>
                <span className="black"> for Growth</span>
              </h2>
              <p className="">Flexible, reliable and built for success across a global business network.</p>
            </div>
          }

        </div>
      </div>
      {/* inner banner wrape END  */}

      {/* inner page content START */}
      <div className="inner-page-content-wrape our-service-wrape">
        <div className='container'>
          {
            selectedLanguage === "en" ? <div className="content-wrape mobile-show page-head">
              <h2 className="mobile-head-text">
                <motion.span className="light animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                >Smarter</motion.span>
                <motion.span className="blue-text animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                > Services</motion.span>
                <motion.span className="black animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}> for Growth</motion.span>
              </h2>
              <motion.p className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                custom={0.1}
                variants={fadeUpVariant}
              >Flexible, reliable and built for global B2B success.</motion.p>
            </div> : <div className="content-wrape mobile-show page-head">
              <h2 className="mobile-head-text">
                <span className="light">Smarter</span>
                <span className="blue-text"> Services</span>
                <span className="black"> for Growth</span>
              </h2>
              <p className="">Flexible, reliable and built for global B2B success.</p>
            </div>
          }


          <div className="subtext-wrape">
            <div className="row">
              <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="head-text">
                  <motion.h2 className="head animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    Flexible Plans
                  </motion.h2>
                  <motion.p className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >At Orex Trade, we know that every business in the global business network is unique with its own supply chain structure, goals and challenges. That’s why we offer flexible plans designed to meet the specific needs of buyers, suppliers and logistics partners alike.</motion.p>
                </div>
              </div>
              <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <motion.p className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.3}
                  variants={fadeUpVariant}
                >Whether you’re looking to expand your supplier network, generate verified leads, promote your brand or streamline logistics, our plans adapt seamlessly to your business objectives. You can choose, combine and scale features based on your requirements ensuring you only pay for what truly adds value to your operations.</motion.p>
                <motion.p className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.3}
                  variants={fadeUpVariant}
                >With Orex Trade, you get access to real-time connectivity and advanced tools that empower you to make smarter business decisions. Our flexible structure allows you to upgrade or modify your plan anytime, supporting your growth at every stage.</motion.p>
              </div>
            </div>
          </div>
        </div>

        {/* cards wrape START */}
        <div class="cards-wrape">
          <div className="container">
            <div class="card c1"></div>
            <div class="card c2"></div>
            <div class="card c3"></div>
            <div class="card c4"></div>
          </div>
        </div>
        {/* cards wrape END */}

        <div className="container">
          <div className="row">
            <div className="col-xxl-3 col-xl-2 col-lg-1"></div>
            <div className="col-xxl-6 col-xl-8 col-lg-9">
              <motion.p className="text-center mt-5 animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                custom={0.3}
                variants={fadeUpVariant}>Experience a network built for collaboration, efficiency and results. Choose Orex Trade where flexibility meets opportunity within a global business network.</motion.p>
            </div>
          </div>
        </div>

        {/* digital wrape START */}
        <div className="digital-wrape content-section-wrape">
          <div className="container">
            <div className='row'>
              <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                <div className='img-wrape'>
                  <motion.img src={OutServiceDigital} alt='Digital & Social Media Promotion' loading="lazy" className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
              </div>
              <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center'>
                <div className='content-wrape'>
                  <div className="head-text">
                    <motion.h2 className="head animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.3}
                      variants={fadeUpVariant}
                    >
                      Digital & Social Media Promotion
                    </motion.h2>
                  </div>

                  <motion.p className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >In today’s digital first global business network, visibility and credibility define success. At Orex Trade, we help your business stand out, engage and grow through powerful digital and social media promotion strategies tailored to your industry and target audience.</motion.p>

                  <motion.p className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >Our expert team creates and manages campaigns across leading digital networks including LinkedIn, Facebook, Instagram and Twitter to connect you with verified buyers, suppliers and logistics partners worldwide. From strategic content creation and brand storytelling to performance marketing and audience retargeting, every campaign is designed to boost your reach, trust and conversions.</motion.p>

                  <motion.p className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >We focus on building a strong, consistent digital identity that enhances your brand reputation, drives meaningful engagement and generates measurable results. With Orex Trade’s digital promotion services, your business doesn’t just get seen, it gets remembered.</motion.p>

                  <motion.h6 className="varient animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >Grow your network. Strengthen your brand. Expand your reach digitally, globally and effectively with Orex Trade.</motion.h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* digital wrape END */}

        {/* shiping service wrape START */}
        <div className="shiping-service-wrape">
          <motion.div className="container animate-child"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            custom={0.1}
            variants={fadeUpVariant}
          >
            <div className="row">
              <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 shipping-banner"></div>
              <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 pe-0 ps-0">
                <div className="detail-section">
                  <div className='content-wrape'>
                    <div className="head-text">
                      <motion.h2 className="head animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        custom={0.3}
                        variants={fadeUpVariant}
                      >
                        Logistics & Shipping Services
                      </motion.h2>
                    </div>

                    <motion.p className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.3}
                      variants={fadeUpVariant}
                    >Reliable logistics are the backbone of global trade and at Orex Trade, we make it seamless. Our network connects you with trusted logistics and shipping partners who specialize in moving goods efficiently, securely and on time across domestic and international markets.</motion.p>

                    <motion.p className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.3}
                      variants={fadeUpVariant}>From freight forwarding and customs clearance to warehousing, inventory management and last-mile delivery, Orex Trade provides end-to-end logistics support for businesses of all sizes. Whether you’re a buyer seeking timely deliveries or a supplier managing large-scale shipments, our network ensures smooth coordination at every step of the supply chain.</motion.p>

                    <motion.p className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.3}
                      variants={fadeUpVariant}>We simplify complex logistics operations by offering competitive freight solutions, efficient partner collaboration and clear communication channels between all
                      parties involved. This ensures fewer delays, reduced costs and greater reliability in every shipment.</motion.p>

                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.3}
                      variants={fadeUpVariant}
                    >With Orex Trade’s Logistics & Shipping Services, you gain more than transport, you gain a strategic logistics advantage that keeps your business moving forward globally.</motion.p>

                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.3}
                      variants={fadeUpVariant}
                    >Simplify your supply chain. Deliver with confidence. Grow with Orex Trade.</motion.p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
        {/* shiping service wrape END */}

        {/* certificate wrape START */}
        <div className="certificate-wrape content-section-wrape">
          <div className="container">
            <div className='row flex-row-reverse '>
              <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                <div className='img-wrape'>
                  <motion.img src={OutServiceCertificate} alt='Digital & Social Media Promotion' loading="lazy"
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
              </div>
              <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center'>
                <div className='content-wrape'>
                  <div className="head-text">
                    <motion.h2 className="head animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.3}
                      variants={fadeUpVariant}
                    >
                      Company Certification Assistance
                    </motion.h2>
                  </div>

                  <motion.p className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >In the competitive global marketplace, credibility is everything. At Orex Trade, we understand that verified certifications play a crucial role in building trust and strengthening business relationships. That’s why we offer comprehensive company certification assistance to help you obtain, manage and showcase your profile with confidence.</motion.p>

                  <motion.p className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >Our team guides you through the entire certification process from identifying the most relevant industry standards and compliance requirements to connecting you with recognized certification bodies. Once approved, we help you feature your certifications prominently on your Orex Trade profile, giving your business instant visibility and credibility among global buyers, suppliers and logistics partners.</motion.p>

                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >With authentic and verifiable certifications, your company stands out as a professional, reliable and quality-driven partner increasing your chances of forming long-term, high-value business collaborations.</motion.p>

                  <motion.h6 className="varient animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >Build trust. Enhance credibility. Grow stronger with Orex Trade Certification Assistance.</motion.h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* certificate wrape END */}

        {/* pramotion wrape START */}
        <div className="pramotion-wrape content-section-wrape">
          <div className="container">
            <div className='row'>
              <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                <div className='img-wrape'>
                  <motion.img src={OutServicePramotion} alt='Digital & Social Media Promotion' loading="lazy"
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
              </div>
              <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center'>
                <div className='content-wrape'>
                  <div className="head-text">
                    <motion.h2 className="head animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.3}
                      variants={fadeUpVariant}
                    >
                      End-to-End Business Promotion
                    </motion.h2>
                  </div>

                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >At Orex Trade, we go beyond connecting you with leads - we help you promote your entire business ecosystem. Our end-to-end business promotion services are designed to give your brand the visibility, credibility and competitive edge it deserves within a global business network.</motion.p>

                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >From targeted advertising campaigns and strategic branding to lead generation and market positioning, we combine traditional trade expertise with modern digital marketing tools to amplify your presence across industries and geographies.</motion.p>

                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >Whether you’re a manufacturer, supplier or logistics partner, our integrated approach ensures your company gains maximum exposure among the right audience. We focus on building lasting brand value while driving measurable business outcomes - helping you expand faster, connect smarter and grow globally.</motion.p>

                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >With Orex Trade’s End-to-End Business Promotion, your success isn’t just visible - it’s unstoppable.</motion.p>

                  <motion.h6 className="varient animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >Promote smarter. Grow faster. Lead globally with Orex Trade.</motion.h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* pramotion wrape END */}

        {/* gray-wrape START */}
        <div className="gray-wrape">
          <div className="container">
            <div className="row flex-row-reverse ">
              <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                <div className='img-wrape'>
                  <motion.img src={OutServiceDedication} alt='Digital & Social Media Promotion' loading="lazy"
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
              </div>
              <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center'>
                <div className='content-wrape'>
                  <div className="head-text">
                    <motion.h2 className="head animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.3}
                      variants={fadeUpVariant}
                    >
                      Dedicated Customer Assistance
                    </motion.h2>
                  </div>

                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >At Orex Trade, we believe that strong partnerships are built on trust, support and long-term
                    collaboration. That’s why our dedicated customer assistance team is always ready to guide
                    you every step of the way.</motion.p>

                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >Whether you’re setting up your business profile, exploring available features, analyzing
                    performance reports or planning your next promotional campaign, our team ensures a
                    smooth and hassle-free experience. We provide personalized guidance tailored to your
                    business goals, helping you make the most of every Orex Trade feature and opportunity.</motion.p>

                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >Our commitment extends beyond support. We act as your growth partner, delivering timely guidance, expert insights and practical solutions to help you thrive in today’s competitive global market.</motion.p>

                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >With Orex Trade’s Dedicated Customer Assistance, you’re never alone, you have a reliable
                    partner focused on your success.</motion.p>

                  <motion.h6 className="varient animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >Your business growth starts with the right support and at Orex Trade, we’re
                    always here to help.</motion.h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* gray-wrape END */}

        {/* verification wrape START */}
        <div className="verification-wrape  content-section-wrape pb-1">
          <div className="container">
            <div className='row'>
              <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                <div className='img-wrape'>
                  <Link to={publicRoutePaths.REGISTRATION.path} href={publicRoutePaths.REGISTRATION.path} target="_blank">
                    <motion.img src={OutServiceVerification} alt='Digital & Social Media Promotion' loading="lazy"
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.3}
                      variants={fadeUpVariant}
                    ></motion.img>
                  </Link>

                </div>
              </div>
              <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center'>
                <div className='content-wrape'>
                  <div className="head-text">
                    <motion.h2 className="head animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.3}
                      variants={fadeUpVariant}
                    >
                      Physical & Reference Verification for Buyers/Suppliers
                    </motion.h2>
                  </div>

                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >Trust and authenticity are the foundation of successful partnerships within a global business network. At Orex Trade, we take
                    every step to ensure that the businesses you connect with are genuine, reliable and credible.
                    Through our Physical and Reference Verification process, we help create a secure and
                    transparent trade environment for both buyers and suppliers.</motion.p>

                  <motion.p className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >Our verification team conducts comprehensive background checks, validating company
                    details, business addresses and operational authenticity. We also perform reference
                    verification by reviewing industry credibility, trade history and partner feedback to confirm
                    the legitimacy of each business listed on our network.</motion.p>

                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >This two-step verification process enhances confidence, reduces the risk of fraud and ensures
                    that every connection you make on Orex Trade is backed by trust and integrity.</motion.p>

                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >With Orex Trade’s Physical & Reference Verification Services, you can engage with verified partners,
                    build lasting relationships and trade with complete peace of mind.</motion.p>

                  <motion.h6 className="varient animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.3}
                    variants={fadeUpVariant}
                  >Connect safely. Trade confidently. Grow with verified partners on Orex Trade.</motion.h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* verification wrape END */}

      </div>
      {/* inner page content END */}
      <ConsentManager data={""} />

      {smallmodalShow && (
        <PopUp
          title="Book A Demo"
          smallmodalShow={smallmodalShow}
          setSmallModalShow={setSmallModalShow}
          className="book-demo"
        >
          <BookADemo
            setSmallModalShow={setSmallModalShow} />
        </PopUp>
      )}
      <ToastContainer />
    </section>
  )
}

export default React.memo(Index);
